import { useHistory } from 'react-router-dom'

const {
  MESSAGE_STR_TYPE_CONFIRMATION,
  MESSAGE_STR_TYPE_WELCOME
} = require('Constants/index')
const { notifyParent } = require('mailup-react-helpers')

function modalMessageRedirect() {
  const history = useHistory()
  const redirect = messageType => {
    switch (messageType) {
      case MESSAGE_STR_TYPE_WELCOME: {
        notifyParent('redirectMainFrame', [
          `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
            '/databasebuilding/subscriptions/welcome/list'
          )}`
        ])
        break
      }
      case MESSAGE_STR_TYPE_CONFIRMATION: {
        notifyParent('redirectMainFrame', [
          `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
            '/databasebuilding/subscriptions/confirmation/list'
          )}`
        ])
        break
      }
      default: {
        history.push('/messages/email/saved')
        break
      }
    }
  }
  return { redirect }
}

export default modalMessageRedirect
